const SPECIAL_SYMBOLS: { [_: string]: string } = {
  '&amp;': '&',
};

export const getSubdomain = (url: string) => {
  let domain = url;
  if (url.includes('://')) {
    domain = url.split('://')[1];
  }
  return domain.split('.')[0];
};

// Function for escaping query params escaped on iterable side
// Firstly trying to escape special symbols(single acknowledged case is ampersand)
// for others just replace "+" symbols to whitespace
export const escapeIterableQueryParam = (queryParam: string) => {
  let result = queryParam;
  for (const [key, value] of Object.entries(SPECIAL_SYMBOLS)) {
    const regexp = new RegExp(key, 'ig');
    console.log(key, regexp, value, queryParam);
    result = result.replace(regexp, value);
  }
  result = result.replace(/\+/g, ' ');
  return result;
};
